<div class="form-group" *ngIf="doorList.length > 0">
  <label for="type"><ng-container i18n="Select door">Select door</ng-container></label>
  <select id="type" name="type" class="form-control" (change)="onDoorSelect($event)" [value]="selectedDoorId">
    <option selected value>-- select an option --</option>
    <option *ngFor="let d of doorList" [value]="d.id">
      <ng-container>{{ d.name }}</ng-container>
    </option>
  </select>
</div>
